export const POINT_BALANCE_CHANGED_EVENT = 'coveauto:point-balance-changed';

export const notifyPointBalanceChanged = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(POINT_BALANCE_CHANGED_EVENT));
};
